var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Fragment, PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { MessageStatus } from '../messageStatus';
export default class StatusIsForward extends PureComponent {
    constructor(props) {
        super(props);
    }
    generateStatusText(csid) {
        return (_jsx(Fragment, { children: _jsxs("span", { children: ["This is a transcript of conversation", ' ', _jsxs(Link, Object.assign({ to: `/conversation/${csid}` }, { children: ["#", csid] }))] }) }));
    }
    render() {
        const _a = this.props, { csid } = _a, otherProps = __rest(_a, ["csid"]);
        return (_jsx(MessageStatus, Object.assign({}, otherProps, { text: this.generateStatusText(csid) })));
    }
}
